<template>
    <v-card v-if="data" style="border-radius:4px;">
        <v-toolbar flat height="45px">
            <span v-if="data.header" class="font-weight-bold ">{{data.header}}</span>
            <v-spacer></v-spacer>
            <v-btn icon @click.native="closeDialog()" >
                <v-icon>close</v-icon>
            </v-btn>
        </v-toolbar>
        <v-card-text >
            <div v-if="data" id="content" class="content">
                <p v-if="data.effectiveDate">Effective Date: {{data.effectiveDate}}</p>
                <p v-html="data.intro"></p>
                <ol>
                    <li v-for="(data,index) in data.details" :key="index">
                        <b v-html="data.title"></b>
                        <p v-if="data.description" v-html="data.description"></p>
                        <ol v-show="data.items.length">
                            <li v-for="(data2,index) in data.items" :key="index">{{data2.item}}</li>
                        </ol>
                    </li>
                </ol>
                <p v-html="data.footer"></p>
            </div>
        </v-card-text>
    </v-card>
</template>
<script>
export default {
    data() {
        return {
            data: null
        }
    },
    methods: { 
        setData(data) {
            this.data = data
            setTimeout(() => {
                document.getElementById('content').scrollTop = 0
            }, 100);
        },
        closeDialog() {
            this.$emit('update:dialog', false)
        },
    },
    computed: {},
    created() {}
}
</script>
<style scoped>
.content {
    height:400px;
    overflow-y:scroll;
    padding:0px 15px 0px 15px;
    margin-bottom:15px;
}
ol {
  list-style-type: none;
  counter-reset: item;
  margin: 0;
  padding: 0;
}
ol > li {
  display: table;
  counter-increment: item;
  margin-bottom: 0.6em;
}
ol > li:before {
  content: counters(item, ".") ". ";
  display: table-cell;
  padding-right: 0.6em;    
}
li ol > li {
  margin: 0;
}
li ol > li:before {
  content: counters(item, ".") " ";
}
</style>